import IncurancesPage from "./InsurancesPage";
export default IncurancesPage;
